import styled from 'styled-components';
export const Content = styled.div `
  color: var(--text-primary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
`;
